export const normFile = (file) => {
  const normalized = { ...file }
  normalized.id = normalized.id ?? normalized.file_id ?? null
  normalized.name = normalized.name ?? normalized.file_name ?? normalized.originalFilename ?? normalized.originalName ?? ''
  normalized.blob_name = normalized.blob_name ?? normalized.blobName ?? normalized.id ?? normalized.file_id ?? ''
  normalized.fileUrl = normalized.fileUrl ?? normalized.url ?? normalized.sasUrl ?? normalized.download_url ?? ''
  const blob = normalized.blob_name ?? normalized.blobName
  normalized.bareUrl = normalized.bareUrl ?? (blob ? `https://wdkbasitesfiles.blob.core.windows.net/sites-files/${blob}` : '')
  normalized.url = normalized.fileUrl || normalized.bareUrl || ''
  normalized.downloadUrl = normalized.fileUrl || normalized.url
  normalized.size = normalized.size ?? null
  normalized.mime = normalized.mime ?? normalized.mimetype ?? normalized.contentType ?? ''
  normalized.fileExtension = normalized.fileExtension ?? normalized.extension ?? null
  normalized.uploadedBy = normalized.uploadedBy ?? null
  return normalized
}

export const uniqByKey = (arr = []) => {
  const seen = new Set()
  return (arr || []).filter((fileItem) => {
    const normalized = normFile(fileItem)
    const key = normalized.blob_name || normalized.url || normalized.id || ''
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export const extractFiles = (res) => {
  if (!res) return []
  if (Array.isArray(res)) return res
  if (Array.isArray(res.files)) return res.files
  if (Array.isArray(res.data?.files)) return res.data.files
  if (Array.isArray(res.data)) return res.data
  if (Array.isArray(res.results)) return res.results
  return []
}

